import { autoUpdateTimezone } from './autoUpdateTimezone';
import UserTimezonesApi from '../api/UserTimezonesApi';
export const HS_STANDARD_TIME_ZONE = 'hs_standard_time_zone';
function getCachedUserObjectTimezone() {
  let value;
  try {
    var _storedValue$time;
    const storedValueStr = localStorage.getItem(HS_STANDARD_TIME_ZONE) || '{}';
    const storedValue = JSON.parse(storedValueStr);
    const TEN_MINUTES = 1000 * 60 * 10;
    const isStale = Date.now() - ((_storedValue$time = storedValue.time) !== null && _storedValue$time !== void 0 ? _storedValue$time : 0) > TEN_MINUTES;
    if (!isStale) {
      value = storedValue.value;
    }
  } catch (e) {
    console.error('Error getting user object timezone', e);
  }
  return value;
}
export function setCachedUserObjectTimezone(value) {
  const cachedValue = {
    value,
    time: Date.now()
  };
  try {
    localStorage.setItem(HS_STANDARD_TIME_ZONE, JSON.stringify(cachedValue));
  } catch (e) {
    console.error('Error setting user object timezone', e);
  }
}

/**
 * Used in conjunction with `I18nProvider` and `userInfo` to
 * set up the User Object Timezone (`I18n.moment.userObjectTz()`)
 *
 * @example
 * ```tsx
 * const I18nProvider = createStandardI18nProvider();
 * const { user, portal, userObjectTimezone } = await userInfo().then(hydrateUserInfo);
 * I18nProvider.setLocale({
 *   locale: user.locale,
 *   langEnabled: user.lang_enabled,
 *   timezone: portal?.timezone,
 *   userObjectTimezone,
 * });
 * ```
 */
export function hydrateUserInfo( /** Data from GET `/login-verify/hub-user-info` */
info,
/**
 * If `true`, skip fetching the user object timezone data (default: `false`).
 * Only use this option if you plan on loading timezone data from another source.
 */
skipMomentDataFetch = false) {
  const {
    user
  } = info;
  // If user has no timezone_id, do nothing, return original info
  const userTimezoneId = getCachedUserObjectTimezone() || user.timezone_id;
  if (!userTimezoneId) {
    return Promise.resolve(info);
  }

  // Don't wait for this to finish, it's unnecessary for page load
  autoUpdateTimezone(user.user_id, userTimezoneId).catch(() => {});
  if (skipMomentDataFetch === true) {
    return Promise.resolve(Object.assign({}, info, {
      userObjectTimezone: {
        id: userTimezoneId
      }
    }));
  }
  return UserTimezonesApi.moment(userTimezoneId).then(({
    data
  }) => {
    return Object.assign({}, info, {
      userObjectTimezone: {
        id: userTimezoneId,
        'moment-data': data
      }
    });
  }).catch(e => {
    console.error(e);
    return info;
  });
}